import { defineAsyncComponent } from 'vue';
import ConditionAnalyzer from '../data/ConditionAnalyzer';
import Tools from '../misc/Tools';
import ViewState from '../viewmodule/ViewState';
import { useRouterCacheStore } from '../store/RouterCacheStore';
import { useTokenStore } from '../store/TokenStore';
import PermissionManager from '../permission/PermissionManage';
import ModuleCenter from '../datamodule/ModuleCenter';
const baseConfig = [
    {
        type: 'menu', isMenu: true, name: '电子书管理', path: 'eBook', children: [
            { type: 'item', path: '/eBook/list', name: '电子书' },
            { type: 'item', path: '/corrigendumlog/list', name: '勘误记录' },
            { type: 'item', path: '/eBook/class/list', name: '图书分类' },
            { type: 'item', path: '/author/list', name: '作者管理' }
        ]
    },
    {
        type: 'menu', isMenu: true, name: '资源管理', path: 'resources', children: [
            { type: 'item', path: '/resources/list', name: '资源库' },
            { type: 'item', path: '/resources/examination/list', name: '资源审阅' }
        ]
    },
    {
        type: 'menu', isMenu: true, name: '知识管理', path: 'know', children: [
            { type: 'item', path: '/knowClass/list', name: '知识分类' },
            { type: 'item', path: '/know/list', name: '知识点' }
        ]
    },
    { type: 'item', path: '/abilityCategory/list', name: '能力分类' },
    { type: 'item', path: '/term/list', name: '术语管理' },
    { type: 'item', path: '/check/list', name: '审核管理' },
    // -------------------------------------------编创后台------------------------------------------------
    {
        type: 'menu', isMenu: true, name: '图书管理', path: 'tatEbk', children: [
            { type: 'item', path: '/tatEbk/ebk/list', name: '电子书' },
            { type: 'item', path: '/tatEbk/class/list', name: '图书分类' },
            { type: 'item', path: '/user/feedBank/list', name: '读者反馈' },
            { type: 'item', path: '/user/review/list', name: '读者留言' },
            { type: 'item', path: '/user/bookMark/list', name: '电子书书签' },
            { type: 'item', path: '/user/statistics/list', name: '用户学习交互' },
            // { type: 'item', path: '/tatEbk/corrigendum/list', name: '读者勘误' }
        ]
    },
    // { type: 'item', path: '/expert/list', name: '专家库' },
    {
        type: 'menu', isMenu: true, name: '商品管理', path: 'commodity', children: [
            { type: 'item', path: '/commodity/commoditySPU/list', name: '商品列表' },
            { type: 'item', path: '/commodity/commodityType/list', name: '商品分类' },
            // { type: 'item', path: '/commodity/commodityBundle/list', name: '商品包' },
            // { type: 'item', path: '/commodity/activationCode/list', name: '激活码管理' }
        ]
    },
    {
        type: 'menu', isMenu: true, name: '商品资源', path: 'wareresource', children: [
            { type: 'item', path: '/wareresource/list', name: '商品资源' },
            // { type: 'item', path: '/wareResource/splitevideo/list', name: '待切分视频' },
            { type: 'item', path: '/wareresource/examination/list', name: '资源审核' }
        ]
    },
    // {
    //     type: 'menu', isMenu: true, name: '知识库', path: 'tatKnow', children: [
    //         { type: 'item', path: '/tatKnow/tatKnowType/list', name: '知识分类' },
    //         { type: 'item', path: '/tatKnow/know/list', name: '知识点' },
    //         { type: 'item', path: '/tatAbilityCategory/capacity/list', name: '能力管理' },
    //         { type: 'item', path: '/tatAbilityCategory/estimate/list', name: '评估指标' }
    //     ]
    // },
    {
        type: 'menu', isMenu: true, name: '订单管理', path: 'orders', children: [
            { type: 'item', path: '/orders/list', name: '订单列表' },
            { type: 'item', path: '/orders/address/list', name: '地址管理' }
        ]
    },
    // {
    //     type: 'menu', isMenu: true, name: '考试管理', path: 'exam', children: [
    //         { type: 'item', path: '/exam/examType/list', name: '考试类型' },
    //         { type: 'item', path: '/exam/exam/list', name: '考试记录' },
    //         { type: 'item', path: '/exam/certificate/list', name: '证书类型' }
    //     ]
    // },
    // {
    //     type: 'menu', isMenu: true, name: '岗位胜任力', path: 'tatAbilityCategory', children: [

    //     ]
    // },
    { type: 'item', path: '/collect/list', name: '收藏记录' },
    { type: 'item', path: '/estimate/list', name: '评估指标' },
    { type: 'item', path: '/qrCode/list', name: '二维码管理' },
    { type: 'item', path: '/cendUser/list', name: 'C端用户管理' },
    // { type: 'item', path: '/adminCheck/list', name: '管理员审核' },
    {
        type: 'menu', isMenu: true, name: '医疗单位管理', path: 'medicalUnit', children: [
            { type: 'item', path: '/medicalUnit/register/list', name: '医疗单位注册' },
            { type: 'item', path: '/medicalUnit/medical/list', name: '医疗单位' },
            { type: 'item', path: '/medicalUnit/dept/list', name: '部门管理' },
            { type: 'item', path: '/medicalUnit/post/list', name: '岗位管理' }
        ]
    },

    // { type: 'item', path: '/information/list', name: '资讯管理' },
    // { type: 'item', path: '/banner/list', name: 'banner管理' },
    {
        type: 'menu', isMenu: true, name: '系统管理', path: 'system', children: [
            { type: 'item', path: '/sysUser/list', name: '用户管理' },
            { type: 'item', path: '/systemuser/menu', name: '菜单管理' },
            { type: 'item', path: '/system/dept/list', name: '部门管理' },
            // { type: 'item', path: '/system/message/list', name: '历史消息' },
            { type: 'item', path: '/sysButton/list', name: '权限管理' },
            { type: 'item', path: '/systemuser/role', name: '角色管理' },
        ]
    }
]
//  window.open(,"_blank")

export const topConfig = [
    // { type: 'item', path: '/page/index', name: '首页' },
    { type: 'item', path: '/tatweb/home', name: '首页' },
    { type: 'item', path: 'http://www.aiyingyiyuan.com/', name: '爱婴医院官网' },
    { type: 'item', path: '/tatweb/ask',name:'考核资讯' },
    { type: 'item', path: '/tatweb/post', name: '岗位胜任力' },
    { type: 'item', path: '/tatweb/postCourse', name: '备考资料' },
    { type: 'item', path: '/tatweb/personal/myCourse', name: '泌乳核心课' },
    { type: 'item', path: '/tatweb/certificateQuery', name: '证书查询' },
    { type: 'item', path: '/tatweb/controller/index', name: '管理员中心', readonly: 'isDepartmentHead' },
    { type: 'item', path: '/tatweb/personal/index', name: '个人中心',readonly:'isLogin' }
]
export const whiteName = ['/tatweb/goods/info', '/tatweb/goods/detail', '/tatweb/postCourse', '/tatweb/post', '/tatweb/postDetail', 'test5', '/tatweb/apply/index', '/tatweb/apply/form', '/tatweb/aboutUs','/tatweb/home','/tatweb/ask', '/tatweb/BehalPay', '/tatweb/guidanceDetail','/tatweb/certificateQuery','/tatweb/introduce','/tatweb/goods/info','/tatweb/honorList','/tatweb/honorDetail']
let navConfig = null;
export const findMenu = (path, node, tag) => {
    // const tokenStore = useTokenStore();
    // if (!tag) tag = tokenStore.tag;
    // if (!node) node = navConfig;
    // let def = null;
    // for (const n of node) {
    //     if (n.children) {
    //         const p = findMenu(path, n.children, tag);
    //         if (p) return p;
    //     } else if (n.path == path) {
    //         if (n.tag == tag) return n;
    //         else if (!n.tag && !def) def = n;
    //     }
    // }
    // return def;
    let query = null;
    path = path.replace(/\/\_([^\/\?]+)/, ($0, $1) => {
        if ($1) query = atob($1);
        return '';
    })
    return PermissionManager.getNavData(path, query);
}

export default baseConfig;

export const routeConfig = [
    { code: 'myhome', name: '我的桌面', module: '', links: ['list'], gatway: 'ebk' },
    // 电子书管理
    { code: 'eBook', name: '电子书', module: 'ebkEBook', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'eBook/class', name: '图书分类', module: 'ebkBookClassify', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'eBook/chapter', name: '电子书章节', module: 'ebkEBookChapter', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'eBook/chapterKnow', name: '章节下知识点', module: 'ebkKnowledgeResource', links: ['view'], gatway: 'ebk' },
    { code: 'eBook/termRel', name: '术语', module: 'ebkTermRel', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'author', name: '作者管理', module: 'mdmAuthor', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'resourceRel', name: '关联资源', module: 'ebkResourceRel', links: ['view'], gatway: 'ebk' },
    { code: 'corrigendumlog', name: '勘误记录', module: 'ebkErrorNotes', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },

    // 资源管理
    { code: 'resources', name: '资源库', module: 'ebkResource', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'resources/examination', name: '资源审阅', module: 'ebkResource', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    // 部门管理

    { code: 'knowClass', name: '知识分类', module: 'kbsKnowledgeCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'know', name: '知识', module: 'kbsKnowledgePoint', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'term', name: '术语管理', module: 'kbsTerm', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },

    { code: 'abilityCategory', name: '能力分类', module: 'kbsAbilityCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'sysResourceRel', name: '相关资源', module: 'sysRel', refCode: 'sysResourceRel', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },
    { code: 'sysebkRel', name: '相关阅读', module: 'sysRel', refCode: 'sysebkRel', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },

    // 审核管理
    { code: 'check', name: '审核管理', module: 'ebkEBookCheck', links: ['view', 'edit', 'create', 'list'], gatway: 'ebk' },

    // -----------------------------------------------------------考培-------------------------------------------------------------------

    // 电子书
    { code: 'tatEbk/ebk', name: '电子书列表', module: 'tatEBook', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatEbk/chapter', name: '电子书章节', module: 'tatEBookChapter', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatEbk/class', name: '图书分类', module: 'tatBookClassify', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'wareresource/resourceRel', name: '关联资源', module: 'tatResourceRel', links: ['view'], gatway: 'tat' },
    { code: 'tatEbk/corrigendum', name: '读者勘误', module: 'tatErrorNotes', links: ['view', 'list'], gatway: 'tat' },
    { code: 'speechreview', name: '敏感字审核', module: '', links: ['view', 'list'], gatway: 'tat' },

    // 商品管理
    { code: 'commodity/commodityType', name: '商品分类', module: 'tatGoodsCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/commodityBundle', name: '商品包', module: 'tatGoodsBundle', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/commoditySPU', name: '商品列表', module: 'tatGoods', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/commoditySKU', name: '商品SKU', module: 'tatGoodsSku', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/specGroup', name: '规格参数组', module: 'tatSpecGroup', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/specParam', name: '规格参数', module: 'tatSpecParam', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/activationCode', name: '激活码管理', module: 'tatCdkRule', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/goodsBundleRel', name: '关联商品', module: 'tatGoodsBundleRel', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'commodity/commodityPicture', name: '商品图片', module: 'tatGoodsPicture', links: ['view', 'edit', 'create'], gatway: 'tat' },
    { code: 'commodity/commodityComment', name: '商品评价', module: 'tatComment', links: ['view'], gatway: 'tat' },


    // 商品资源
    { code: 'wareresource', name: '商品资源', module: 'tatResource', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'wareresource/splitevideo', name: '待切分视频', module: 'tatResource', links: ['view', 'list'], gatway: 'tat' },
    { code: 'wareresource/examination', name: '商品资源审核', module: 'tatResource', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    // 考培-知识
    { code: 'tatKnow/tatKnowType', name: '知识分类', module: 'tatKnowledgeCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatKnow/know', name: '知识', module: 'tatKnowledgePoint', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    // 岗位胜任力管理
    { code: 'tatAbilityCategory/capacity', name: '能力管理', module: 'tatAbilityCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatAbilityCategory/knowAbilityRel', name: '关联能力分类', module: 'tatKnowledgeAbility', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatAbilityCategory/evluateIndex', name: '关联知识', module: 'tatEvaluateIndexRel', links: ['view'], gatway: 'tat' },
    { code: 'tatAbilityCategory/abilityCategoryDesc', name: '等级划分', module: 'tatAbilityDescription', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'tatAbilityCategory/estimate', name: '评估指标', module: 'kbsEvaluateIndex', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    // 订单管理
    { code: 'orders', name: '订单列表', module: 'tatOrder', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'orders/orderDetail', name: '订单详情', module: 'tatOrderDetail', links: ['view'], gatway: 'tat' },
    { code: 'orders/address', name: '地址管理', module: 'tatUserAddress', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    // 考试管理
    { code: 'exam/examType', name: '考试类型', module: 'tatExamType', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'exam/exam', name: '考试记录', module: 'tatExam', links: ['view', 'list'], gatway: 'tat' },
    { code: 'exam/certificate', name: '证书类型', module: 'tatCertCategory', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'exam/userCertificate', name: '用户证书', module: 'tatUserCert', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    { code: 'expert', name: '专家库', module: 'tatAuthor', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'information', name: '资讯管理', module: 'tatAyNews', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'banner', name: 'banner管理', module: 'sysBanner', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    //    用户管理
    { code: 'cendUser', name: '用户列表', module: 'cendUser', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'sysUser', name: '用户列表', module: 'sysUser', links: ['view', 'edit', 'create', 'list'], gatway: 'system' },
    { code: 'user/feedBank', name: '读者反馈', module: 'tatFeedback', links: ['view', 'list'], gatway: 'tat' },
    { code: 'user/review', name: '读者留言', module: 'tatReview', links: ['view', 'list'], gatway: 'tat' },
    { code: 'user/bookMark', name: '用户书签', module: 'tatEbookBookmark', links: ['view', 'list'], gatway: 'tat' },
    { code: 'user/studylog', name: '用户学习记录', module: 'tatLearnRecord', links: ['view', 'list'], gatway: 'tat' },
    { code: 'user/statistics', name: '用户行为统计', module: 'sysReadOperationBuriedPoint', links: ['view', 'list'], gatway: 'tat' },

    // 收藏记录

    { code: 'collect', name: '收藏记录', module: 'tatCollect', links: ['list'], gatway: 'tat' },
    { code: 'estimate', name: '评估指标', module: 'kbsEvaluateIndex', refCode: 'estimate', links: ['view', 'list'], gatway: 'tat' },
    { code: 'user/appay', name: '协作申请管理', module: 'tatAyCoopApply',links: ['view', 'list'], gatway: 'tat' },
    // 二维码管理
    { code: 'qrCode', name: '二维码管理', module: 'sysQrCodeManagement', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    // { code: 'adminCheck', name: '管理员审核', module: 'mdmCompany', links: ['view', 'edit', 'create', 'list'] },

    { code: 'medicalUnit/register', name: '医疗单位注册', module: 'mdmCompanyRegistration', links: ['view','edit', 'list'], gatway: 'tat' },
    { code: 'annex', name: '附件', module: 'sysAttachment', links: ['view', 'list'], gatway: 'tat' },

    { code: 'medicalUnit/medical', name: '医疗单位', module: 'mdmCompany', refCode: 'medical', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'medicalUnit/dept', name: '部门管理', module: 'sysDept', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'medicalUnit/childdept', name: '部门管理', module: 'sysDept', refCode: 'childDept', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },
    { code: 'medicalUnit/post', name: '岗位管理', module: 'sysPost', links: ['view', 'edit', 'create', 'list'], gatway: 'tat' },

    { code: 'dept', name: '部门管理', module: 'sysDept', links: ['view', 'edit', 'create', 'list'], gatway: 'system' },
    { code: 'sysButton', name: '权限管理', module: 'sysButton', links: ['view', 'edit', 'create', 'list'], gatway: 'system' },
    { code: 'cendUser/postdeptrel', name: '部门管理', module: 'sysPostDeptRel', links: ['edit'], gatway: 'system' },

]

const findRouteInfo = (code) => {
    for (const config of routeConfig) {
        if (code == config.code) return config;
    }
    return null;
}

export const getRouteInfo = (path) => {
    if (!/\/([\w\/]+)\/(\w+)(?:\?|$)/.test(path)) return null;
    const code = RegExp.$1;
    const mode = RegExp.$2;
    const routeInfo = findRouteInfo(code);
    if (!routeInfo) return null;
    return { route: routeInfo, mode: mode };
}
const formatObject = (object, stack) => {
    if (!stack) stack = [];
    if (object.target) {
        const key = object.target;
        const opt = object.opt;
        const value = opt == 'in' ? Object.keys(object.value) : object.value;
        let optv = null;
        if (object.not) {
            switch (opt) {
                case 'like': optv = 0; break;
                case '>':
                case '>=': optv = 6; break;
                case '<':
                case '<=': optv = 5; break;
                case '==': optv = 4; break;
                case '!=': optv = 1; break;
                case 'in': optv = 3; break;
            }
        } else {
            switch (opt) {
                case 'like': optv = 0; break;
                case '>':
                case '>=': optv = 5; break;
                case '<':
                case '<=': optv = 6; break;
                case '==': optv = 1; break;
                case '!=': optv = 4; break;
                case 'in': optv = 2; break;
            }
        }
        stack.push({ key: key, value: value, type: optv });
    } else {
        formatObject(object.left, stack);
        formatObject(object.right, stack);
    }
    return stack;
}
export const getRouteCondition = (path) => {
    const routeInfo = getRouteInfo(path);
    if (!routeInfo || !routeInfo.route.condition) return null;
    const condition = routeInfo.route.condition;
    const res = ConditionAnalyzer.toObject(condition.replace(/\=\=/g, '='));
    return formatObject(res);
}
export const isRootRoute = (path) => {
    return !!findMenu(path);
}

export const getRouteName = (path) => {
    // PermissionManager.getPermission(path.replace(/\/\w+$/, '/list'))
    // const menu = findMenu(path.replace(/\/\w+$/, ''));
    // let name = menu ? (menu.name + ' / ') : null;
    let filter = null;
    let mode = 'list';
    path = path.replace(/\?.*?$/, '');
    path = path.replace(/\/\_([^\/\?]+)/, ($0, $1) => {
        if ($1) filter = atob($1);
        return '';
    }).replace(/\/(\w+)$/, ($0, $1) => {
        if ($1) mode = $1;
        return '';
    });
    const routeInfo = PermissionManager.getNavData(path + '/list', filter);
    if (!routeInfo) return null;
    let name = routeInfo.menuName;
    // let name = routeInfo.route.name || '';
    switch (mode) {
        case 'list': name += '列表'; break;
        case 'view': name += '详情'; break;
        case 'edit': name = '编辑' + name; break;
        case 'create': name = '创建' + name; break;
    }
    // if (menu) return menu.name + ' / ' + name;
    return name;
}
export const testRoot = (path) => {
    const store = useRouterCacheStore();
    const menu = findMenu(path.replace);
    return store.keepAliveStack.length || !!menu;
}

const formatCondition = (condition) => {
    if (!condition) return null;
    const condobj = Tools.getQuotes(condition);
    const strmap = condobj.strmap;
    condition = condobj.output;
    condition = condition.replace(/([a-zA-z][\w\.]*)/, 'data.$1').replace(/\{(\d+)\}/g, ($0, $1) => {
        return JSON.stringify(strmap[$1]);
    });
    return new Function('data', 'return ' + condition);
}

const testCondition = (data, route) => {
    if (!data || !route.condition) return true;
    let testFunc = route.testFunc;
    if (!testFunc) testFunc = route.testFunc = ConditionAnalyzer.analyze(route.condition).testFunc;
    return testFunc(data);
}

export const getViewUrl = (data, module) => {
    const m = ModuleCenter.getModule(module);
    const mcode = module + '.' + m.defaultKeyField();
    // const module = view.getModuleCode() + '.' + view.defaultKeyField();
    const key = m.dataKey(data);
    const path = getRoutePath(module, data, ViewState.VIEW);
    const query = `?token=${btoa(mcode + ':' + key)}&state=${ViewState.VIEW}`;
    return window.location.origin + window.location.pathname + '#' + path + query;
}
export const getRoutePath = (module, data, mode) => {
    if (!mode) mode = ViewState.VIEW;
    for (const route of routeConfig) {
        if ((route.refCode == module || route.module == module) && testCondition(data, route)) {
            const link = route.links.indexOf(mode) >= 0 ? mode : route.links[0];
            return '/' + route.gatway + '/' + route.code + '/' + link;
        }
    }
    return null;
}
export const getServerHost = () => {
    return window.location.origin;
}

export const getRoutes = () => {
    const routes = [];
    for (const config of routeConfig) {
        for (const link of config.links) {
            const path = '/' + config.gatway + '/' + config.code + '/' + link;
            // const src = '../viewmodule/XPageView.vue?' + Math.random();
            /* @vite-ignore */
            // @ts-ignore
            routes.push({ path: path, component: defineAsyncComponent(() => import('../viewmodule/XPageView.vue')) });
        }
    }
    return routes;
}
export const getPermissioNavConfig = (Permissions) => {
    // return navConfig
    const map = {}
    Permissions.forEach(it => {
        map[it] = 1
    })
    // console.log(Permissions,map)
    const root = getData(map);
    // for (const n of baseConfig) {
    //     const d = getData(n, map);
    //     if (d) root.push(d);
    // }
    return navConfig = root;
}

const getData = (permissionMap, datas, tag) => {
    const tokenStore = useTokenStore();
    if (!tag) tag = tokenStore.tag;
    if (!datas) datas = baseConfig;

    const res = [];
    let defMap = {};
    for (const data of datas) {
        const path = data.path;
        if (permissionMap[path]) {
            const rData = Object.assign({}, data);
            if (!defMap[path]) {
                defMap[path] = rData;
                res.push(rData);
            } else {
                if (data.tag == tag) {
                    const dData = defMap[path];
                    Object.assign(dData, rData);
                }
            }
        }
        if (data.children && data.children.length) {
            const rData = defMap[path];
            if (rData) {
                rData.children = getData(permissionMap, rData.children, tag);
            }
        }
    }
    return baseConfig;
    // return data
    // if (data.path) {
    //     if (!permissionMap[data.path]) return null;
    // }
    // if (datas) {

    // } else {
    //     return Object.assign({}, data);
    // }
}